// extracted by mini-css-extract-plugin
export var cardHeader = "_gs-0";
export var reorderHandle = "_gs-3";
export var titleArea = "_gs-1";
export var titleAreaWithHandle = "_gs-2";